$(document).ready(function(){
    $(document).on('change','.bundleproduct-detail-blocks .input_bundle_product', function(){
        var $this = $(this);
        var btnType = $this.children('.button').data('update-quantity');
        var qtyinput = $this.siblings('.quantity-wrapper').children('.quantity-input-control').find(".quantity-input");
        var inputValue = qtyinput.val();
        var bundleProductId = $this.val();
        var bundleProductName = $this.siblings('.product-title-price').find('.product_title').children('a').text();
        var bundleProductPrice = $this.siblings('.product-title-price').find('.product-price').find('span').data('price');
        var bundleProductcurrency = $this.siblings('.product-title-price').find('.product-price').find('span').data('currency');
        var totalPrice = $('.overview-product-total .total-value').attr('data-total');
        var productTotal = bundleProductPrice*inputValue;
      
        if(this.checked){
            $('.quantity-minus.button').attr('disabled',false);
            if($('.overview-product[data-id="'+bundleProductId+'"]').length <= 0){
                var bundleHtml = '';
                bundleHtml +=`<li class="overview-product" data-id="${bundleProductId}">
                <span class="overview-product-title">${bundleProductName}</span>
                <span class="overview-product-qty">x ${inputValue}</span>
                <span class="overview-product-price" data-price="${productTotal}">${bundleProductcurrency}${numberWithCommas((productTotal).toFixed(2))}</span>
              </li>`;
              $('.overview-product').last().after(bundleHtml);
            }else{
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-title').text(bundleProductName);
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-qty').text('x '+inputValue);
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-price').text(bundleProductcurrency+numberWithCommas((productTotal).toFixed(2)));
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-price').attr('data-price',productTotal);
            }
            var totalFinalPrice = (parseFloat(totalPrice)+parseFloat(productTotal)).toFixed(2);
            var totalFinalDataPrice = (parseFloat(totalPrice)+parseFloat(productTotal)).toFixed(2);
            console.log('checked');  
        }else{
          console.log('not checked');
            $this.children('.button').attr('disabled',true);
            $('.overview-product[data-id="'+bundleProductId+'"]').remove();
            var totalFinalPrice = (parseFloat(totalPrice)-parseFloat(productTotal)).toFixed(2);
            var totalFinalDataPrice = (parseFloat(totalPrice)-parseFloat(productTotal)).toFixed(2);
            
        } 
        if(inputValue >= 0){
            $('.product-atc .button .total-value').text(bundleProductcurrency+numberWithCommas(totalFinalPrice));
            $('.product-atc .button .total-value').attr('data-total',totalFinalDataPrice);
            $('.bundle-product-submit .total-value').text(bundleProductcurrency+numberWithCommas(totalFinalPrice));
            $('.bundle-product-submit .total-value').attr('data-total',totalFinalDataPrice);
            $('.overview-product-total .total-value').text(bundleProductcurrency+numberWithCommas(totalFinalPrice));
            $('.overview-product-total .total-value').attr('data-total',totalFinalDataPrice);
        }
        qtyinput.val(inputValue);
    });



    $(document).on('click','.bundleproduct-block .control-btn.minus-control',function(){

      var $this = $(this).closest('.bundleproduct-block').find('.input_bundle_product')
        var btnType = $this.children('.button').data('update-quantity');
        var qtyinput = $this.siblings('.quantity-wrapper').children('.quantity-input-control').find(".quantity-input");
        var inputValue = qtyinput.val();
        var bundleProductId = $this.val();
        var bundleProductName = $this.siblings('.product-title-price').find('.product_title').children('a').text();
        var bundleProductPrice = $this.siblings('.product-title-price').find('.product-price').find('span').data('price');
        var bundleProductcurrency = $this.siblings('.product-title-price').find('.product-price').find('span').data('currency');
        var totalPrice = $('.overview-product-total .total-value').attr('data-total');
        var productTotal = bundleProductPrice*inputValue;


        var ths = $(this);
        var val = ths.closest('.bundleproduct-block').find('.quantity-input').val();
        var minval = ths.closest('.bundleproduct-block').find('.quantity-input').attr('min');
        
        if(val == minval ){
          ths.closest('.bundleproduct-block').find('input[type="checkbox"]').prop('checked',false);
          
          console.log('this will work');
          $('.overview-product[data-id="'+bundleProductId+'"]').remove();
          var totalFinalPrice = (parseFloat(totalPrice)-parseFloat(productTotal)).toFixed(2);
          var totalFinalDataPrice = (parseFloat(totalPrice)-parseFloat(productTotal)).toFixed(2);


        }
    });


    $(document).on('click','.bundleproduct-detail-blocks .control-btn', function(){
        var $this = $(this);
        var btnType = $this.children('.button').data('update-quantity');
        var qtyinput = $this.siblings('.quantity-input-control').find(".quantity-input");
        var inputValue = qtyinput.val();
        var mininputvalue = qtyinput.attr('min');
        var bundleProductId = $this.parents('.quantity-wrapper').siblings('.input_bundle_product').val();
        var bundleProductName = $this.parents('.quantity-wrapper').siblings('.product-title-price').find('.product_title').children('a').text();
        var bundleProductPrice = $this.parents('.quantity-wrapper').siblings('.product-title-price').find('.product-price').find('span').data('price');
        var totalbundleProductPrice = bundleProductPrice*inputValue;
        var bundleProductcurrency = $this.parents('.quantity-wrapper').siblings('.product-title-price').find('.product-price').find('span').data('currency');
        var totalPrice = $('.overview-product-total .total-value').attr('data-total');
        var checkboxinput = $this.parents('.quantity-wrapper').siblings('.input_bundle_product').is(":checked");
        var productTotal = bundleProductPrice*inputValue;
        if(btnType == 'plus'){
          inputValue = parseInt(inputValue)+parseInt(1);	 
          $('.bundleproduct-detail-blocks .control-btn.minus-control').css({
        	  "pointer-events": "auto"
          });
          $('.bundleproduct-detail-blocks .control-btn.minus-control').attr('disabled',false);
        }else{
          if(inputValue == mininputvalue){
        	$this.css({
        		"pointer-events": "none"
        	});
        	$('this').attr('disabled',true);
        	console.log('false');
          }
          else{
        	$this.css({
        		"pointer-events": "auto"
        	});
        	$('this').attr('disabled',false);
        	console.log('true');
        	inputValue = parseInt(inputValue)-parseInt(1);
          }
        }
        var productTotal = bundleProductPrice*inputValue;
        if(inputValue > 0){
            if(checkboxinput){
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-title').text(bundleProductName);
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-qty').text('x '+inputValue);
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-price').text(bundleProductcurrency+numberWithCommas((productTotal).toFixed(2)));
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-price').attr('data-price',productTotal);
            }
        }else{
            $this.children('.button').attr('disabled',true);
            $('.overview-product[data-id="'+bundleProductId+'"]').remove();
        }

        if(inputValue >= 0){
            var totalFinalPrice = 0;
            var totalFinalDataPrice = 0;
            $('.overview-box .overview-product').each(function(){
                var $that = $(this);
                var overview_product_price = $that.children('.overview-product-price').attr('data-price');
                var totalFinalDataPrice = (parseFloat(totalFinalPrice)+parseFloat(overview_product_price)).toFixed(2);
                totalFinalPrice = (parseFloat(totalFinalPrice)+parseFloat(overview_product_price)).toFixed(2);
                
            });
            $('.overview-product-total .total-value').text(bundleProductcurrency+numberWithCommas(totalFinalPrice));
            $('.overview-product-total .total-value').attr('data-total',totalFinalPrice);
            $('.bundle-product-submit .total-value').text(bundleProductcurrency+numberWithCommas(totalFinalPrice));
            $('.bundle-product-submit .total-value').attr('data-total',totalFinalPrice);
            $('.product-atc .button .total-value').text(bundleProductcurrency+numberWithCommas(totalFinalPrice));
            $('.product-atc .button .total-value').attr('data-total',totalFinalPrice);
        }
        
        qtyinput.val(inputValue);
    });

    $(document).on('click','.product-quantity-box .control-btn',function(){
        var $this = $(this);
        var btnType = $this.children('.button').data('update-quantity');
        var qtyinput = $this.siblings('.quantity-input-control').find(".quantity-input");
        var inputValue = qtyinput.val();
        var mininputvalue = qtyinput.attr('min');
        var productPrice = $('#main_product_price').val();
        var totalPrice = $('.overview-product-total .total-value').attr('data-total');
        var productId = $('#main_product_price').attr('data-id');
        var productCurrency = $('#main_product_price').data('currency');
        var productTotal = productPrice*inputValue;
        
        if(btnType == 'plus'){
          $('.product-quantity-box .control-btn.minus-control').css({
              "pointer-events": "auto"
          });
          $('.product-quantity-box .control-btn.minus-control').attr('disabled',false);
          var totalFinalPrice = (parseFloat(totalPrice)+parseFloat(productPrice)).toFixed(2);
          var totalFinalDataPrice = (parseFloat(totalPrice)+parseFloat(productPrice)).toFixed(2);
        }else{
          if(inputValue == mininputvalue){
            $this.css({
                "pointer-events": "none"
            });
            $('this').attr('disabled',true);
            console.log('false');
            var totalFinalPrice = (parseFloat(totalPrice)-parseFloat(productPrice)).toFixed(2);
            var totalFinalDataPrice = (parseFloat(totalPrice)-parseFloat(productPrice)).toFixed(2);
          }
          else{
            $this.css({
                "pointer-events": "auto"
            });
            $('this').attr('disabled',false);
            console.log('true');
            var totalFinalPrice = (parseFloat(totalPrice)-parseFloat(productPrice)).toFixed(2);
            var totalFinalDataPrice = (parseFloat(totalPrice)-parseFloat(productPrice)).toFixed(2);
          }
        }
        console.log(inputValue,mininputvalue,totalPrice,totalFinalPrice);  
        if(inputValue>0){
            $('.overview-product[data-id="'+productId+'"] .overview-product-qty').text('x '+inputValue);
            $('.overview-product[data-id="'+productId+'"] .overview-product-price').text(productCurrency+numberWithCommas((productTotal).toFixed(2)));
            $('.overview-product[data-id="'+productId+'"] .overview-product-price').attr('data-price',productTotal);
        
            $('.overview-product-total .total-value').text(productCurrency+numberWithCommas(totalFinalPrice));
            $('.overview-product-total .total-value').attr('data-total',totalFinalDataPrice);

            $('.product-atc .button .total-value').text(productCurrency+numberWithCommas(totalFinalPrice));
            $('.product-atc .button .total-value').attr('data-total',totalFinalDataPrice);

            $('.purchase-details__buttons .total-value').text(productCurrency+numberWithCommas(totalFinalPrice));
            $('.purchase-details__buttons .total-value').attr('data-total',totalFinalDataPrice);
            

        }
    });

    $(document).on('change, keyup','.bundleproduct-detail-blocks .quantity-input',function(){
        var $this = $(this);
        var inputValue = $this.val();
        var mininputvalue = $this.attr('min');
        var bundleProductId = $this.parents('.quantity-wrapper').siblings('.input_bundle_product').val();
        var bundleProductName = $this.parents('.quantity-wrapper').siblings('.product-title-price').find('.product_title').children('a').text();
        var bundleProductPrice = $this.parents('.quantity-wrapper').siblings('.product-title-price').find('.product-price').find('span').data('price');
        var bundleProductcurrency = $this.parents('.quantity-wrapper').siblings('.product-title-price').find('.product-price').find('span').data('currency');
        var totalPrice = $('.overview-product-total .total-value').attr('data-total');
        var productTotal = bundleProductPrice*inputValue;
        var checkboxinput = $this.parents('.quantity-wrapper').siblings('.input_bundle_product').is(":checked");
        if(inputValue == mininputvalue){
          $('.bundleproduct-detail-blocks .control-btn.minus-control').css({
              "pointer-events": "none"
          });
          $('.bundleproduct-detail-blocks .control-btn.minus-control').attr('disabled',true);
        }
        else{
          $('.bundleproduct-detail-blocks .control-btn.minus-control').css({
              "pointer-events": "auto"
          });
          $('.bundleproduct-detail-blocks .control-btn.minus-control').attr('disabled',false);
        }
        if(inputValue > 0){
          if(checkboxinput){
            if($('.overview-product[data-id="'+bundleProductId+'"]').length <= 0){
                var bundleHtml = '';
                bundleHtml +=`<li class="overview-product" data-id="${bundleProductId}">
                <span class="overview-product-title">${bundleProductName}</span>
                <span class="overview-product-qty">x ${inputValue}</span>
                <span class="overview-product-price" data-price="${productTotal}">${bundleProductcurrency}${numberWithCommas((productTotal).toFixed(2))}</span>
              </li>`;
              $('.overview-product').last().after(bundleHtml);
            }else{
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-title').text(bundleProductName);
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-qty').text('x '+inputValue);
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-price').text(bundleProductcurrency+numberWithCommas((productTotal).toFixed(2)));
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-price').attr('data-price',productTotal);
            }
          }
        }else{
            $('.overview-product[data-id="'+bundleProductId+'"]').remove();
        }

        if(inputValue >= 0){
            var totalFinalPrice = 0;
            var totalFinalDataPrice = 0;
            $('.overview-box .overview-product').each(function(){
                var $that = $(this);
                var overview_product_price = $that.children('.overview-product-price').attr('data-price');
                var totalFinalDataPrice = (parseFloat(totalFinalPrice)+parseFloat(overview_product_price)).toFixed(2);
                totalFinalPrice = (parseFloat(totalFinalPrice)+parseFloat(overview_product_price)).toFixed(2);
            });
            $('.overview-product-total .total-value').text(bundleProductcurrency+numberWithCommas(totalFinalPrice));
            $('.overview-product-total .total-value').attr('data-total',totalFinalPrice);
        }
    });

    $(document).on('change, keyup','.product-quantity-box .quantity-input',function(){
        var $this = $(this);
        var inputValue = $this.val();
        var productPrice = $('#main_product_price').val();
        var totalPrice = $('.overview-product-total .total-value').attr('data-total');
        var productId = $('#main_product_price').attr('data-id');
        var productCurrency = $('#main_product_price').data('currency');
        var productTotal = productPrice*inputValue;
        var mininputvalue = $this.attr('min');
        if(inputValue == mininputvalue){
          $('.product-quantity-box .control-btn.minus-control').css({
              "pointer-events": "none"
          });
          $('.product-quantity-box .control-btn.minus-control').attr('disabled',true);
        }
        else{
          $('.product-quantity-box .control-btn.minus-control').css({
              "pointer-events": "auto"
          });
          $('.product-quantity-box .control-btn.minus-control').attr('disabled',false);
        }
        if(inputValue>0){
            $('.overview-product[data-id="'+productId+'"] .overview-product-qty').text('x '+inputValue);
            $('.overview-product[data-id="'+productId+'"] .overview-product-price').text(productCurrency+numberWithCommas((productTotal).toFixed(2)));
            $('.overview-product[data-id="'+productId+'"] .overview-product-price').attr('data-price',productTotal);

            var totalFinalPrice = 0;
            $('.overview-box .overview-product').each(function(){
                var $that = $(this);
                var overview_product_price = $that.children('.overview-product-price').attr('data-price');
                totalFinalPrice = (parseFloat(totalFinalPrice)+parseFloat(overview_product_price)).toFixed(2);
            });
            
            $('.overview-product-total .total-value').text(productCurrency+numberWithCommas(totalFinalPrice));
            $('.overview-product-total .total-value').attr('data-total',totalFinalPrice);
        }
    });
    
      $(document).on('click', '.bundle-product-submit', function(){
        if($('.input_bundle_product').is(":checked")){
        event.preventDefault();
        var $this = $(this);
        var items = [];
        $('.input_bundle_product').each(function(i){
            var id = $(this).val();
            var item = {};
            // this.checked
            if(this.checked){
                item['quantity'] = $('.bundleproduct-detail-blocks').children('.bundleproduct-block').eq(i).find('.quantity-input').val();
                item['id'] = id;
                items.push(item);
            }
        });
        if(items.length > 0){
            $.ajax({
             method:'post',
             url:'/cart/add.js',
             data: {items},
             dataType: 'json',
             beforeSend:function() {
               $this.removeClass('is-added').addClass('is-adding');
               $this.html('<i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i><span class="sr-only">Loading...</span>');
               $this.attr('disabled',true);
             },
             success:function(data){
               $.ajax({
                   method:'post',
                   url:'/cart/add.js',
                   data:$('.addToCart').serialize(),
                   dataType: 'json',
                   success:function(data){
                     $('.remain-box-error').text('');
                     $('.remain-box-error').addClass('hidden');
                     window.location="/cart";
                   }
               });
             },
             complete: function(){
               $this.removeClass('is-adding').addClass('is-added');
             }
            });
        }
        }  
    })  
    
});

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function titlemaxheight() {
    var maxHeight = -1;
    $('#template-page-support .icon-column__title').each(function() {
    maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
    $(this).height( maxHeight);
    });
}
$(document).ready(function(){
    titlemaxheight();
});
$(window).on('resize',function(){
    titlemaxheight();
})